import { GOOGLE_PLACES_CONFIG } from '../config/googlePlaces';

class GoogleReviewsService {
  constructor() {
    this.cache = new Map();
    this.cacheTimeout = null;
  }

  // Fetch reviews from our PHP proxy
  async fetchReviews() {
    try {
      // Check cache first
      const cachedData = this.getCachedReviews();
      if (cachedData) {
        return cachedData;
      }

      // Use our PHP proxy instead of direct Google API call
      const proxyUrl = '/google-reviews-proxy.php';
      
      const response = await fetch(proxyUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Cache the results
      this.cacheReviews(data);

      return data;

    } catch (error) {
      console.error('Error fetching Google reviews:', error);
      
      // Return fallback data if API fails
      return this.getFallbackReviews();
    }
  }

  // Cache reviews with timestamp
  cacheReviews(data) {
    const cacheData = {
      data,
      timestamp: Date.now()
    };
    this.cache.set('reviews', cacheData);
    
    // Clear cache after duration
    if (this.cacheTimeout) {
      clearTimeout(this.cacheTimeout);
    }
    this.cacheTimeout = setTimeout(() => {
      this.cache.delete('reviews');
    }, GOOGLE_PLACES_CONFIG.CACHE_DURATION);
  }

  // Get cached reviews if still valid
  getCachedReviews() {
    const cached = this.cache.get('reviews');
    if (!cached) return null;

    const isExpired = Date.now() - cached.timestamp > GOOGLE_PLACES_CONFIG.CACHE_DURATION;
    if (isExpired) {
      this.cache.delete('reviews');
      return null;
    }

    return cached.data;
  }

  // Fallback reviews if API fails
  getFallbackReviews() {
    return {
      reviews: [
        {
          id: 'fallback-1',
          name: 'Priya Sharma',
          title: 'Patient',
          text: 'Amazing experience at Shirkande Clinic! The orthodontic treatment with invisible braces was excellent. The entire team is so professional and caring. Highly recommend!',
          rating: 5,
          initials: 'PS',
          date: '2 weeks ago',
          profilePhoto: null,
          relativeTime: '2 weeks ago',
          language: 'en'
        },
        {
          id: 'fallback-2',
          name: 'Rajesh Patel',
          title: 'Patient',
          text: 'Had a root canal treatment here and it was completely painless. The doctor is very skilled and explains everything clearly. The clinic is modern and hygienic.',
          rating: 5,
          initials: 'RP',
          date: '1 month ago',
          profilePhoto: null,
          relativeTime: '1 month ago',
          language: 'en'
        },
        {
          id: 'fallback-3',
          name: 'Meera Desai',
          title: 'Patient',
          text: 'The pediatric dentist is wonderful with kids! My 8-year-old daughter actually looks forward to her dental checkups. The clinic environment is so child-friendly.',
          rating: 5,
          initials: 'MD',
          date: '3 weeks ago',
          profilePhoto: null,
          relativeTime: '3 weeks ago',
          language: 'en'
        },
        {
          id: 'fallback-4',
          name: 'Amit Patel',
          title: 'Patient',
          text: 'The dental hygienist was very thorough and explained everything clearly. The clinic is clean and the staff is friendly. I highly recommend!',
          rating: 5,
          initials: 'AP',
          date: '2 months ago',
          profilePhoto: null,
          relativeTime: '2 months ago',
          language: 'en'
        },
        {
          id: 'fallback-5',
          name: 'Neha Gupta',
          title: 'Patient',
          text: 'The root canal treatment was painless and the recovery was quick. The clinic is modern and the staff is very friendly. I highly recommend!',
          rating: 5,
          initials: 'NG',
          date: '1 month ago',
          profilePhoto: null,
          relativeTime: '1 month ago',
          language: 'en'
        },
        {
          id: 'fallback-6',
          name: 'John Doe',
          title: 'Patient',
          text: 'Had a root canal treatment here and it was completely painless. The doctor is very skilled and explains everything clearly. The clinic is modern and hygienic.',
          rating: 5,
          initials: 'JD',
          date: '1 month ago',
          profilePhoto: null,
          relativeTime: '1 month ago',
          language: 'en'
        },
        {
          id: 'fallback-7',
          name: 'Harsh Patel',
          title: 'Patient',
          text: 'Had a root canal treatment here and it was completely painless. The doctor is very skilled and explains everything clearly. The clinic is modern and hygienic.',
          rating: 5,
          initials: 'HP',
          date: '1 month ago',
          profilePhoto: null,
          relativeTime: '1 month ago',
          language: 'en'
        },
        {
          id: 'fallback-8',
          name: 'Swati Sharma',
          title: 'Patient',
          text: 'Had a root canal treatment here and it was completely painless. The doctor is very skilled and explains everything clearly. The clinic is modern and hygienic.',
          rating: 5,
          initials: 'SS',
          date: '1 month ago',
          profilePhoto: null,
          relativeTime: '1 month ago',
          language: 'en'
        },
        {
          id: 'fallback-9',
          name: 'Rajesh Kumar',
          title: 'Patient',
          text: 'Had a root canal treatment here and it was completely painless. The doctor is very skilled and explains everything clearly. The clinic is modern and hygienic.',
          rating: 5,
          initials: 'RK',
          date: '1 month ago',
          profilePhoto: null,
          relativeTime: '1 month ago',
          language: 'en'
        }
      ],
      overallRating: 4.8,
      totalReviews: 160,
      lastUpdated: new Date().toISOString()
    };
  }

  // Clear cache manually
  clearCache() {
    this.cache.clear();
    if (this.cacheTimeout) {
      clearTimeout(this.cacheTimeout);
    }
  }
}

// Export singleton instance
export const googleReviewsService = new GoogleReviewsService();
